const messages = {
  video: {
    title: '沉浸在诗情画意的世界中',
    cta: '观看预告'
  },
  keypoints: {
    point1: '沉浸在诗意和艺术的宇宙中',
    point2: '探索当代创作的主要元素',
    point3: '徜徉在欧洲最大的现当代艺术馆藏'
  },
  themes: {
    title1: '颜色与系统',
    content1: ' 这一层分为两个视觉系统，您需要遵循对称原则，将颜色合并到镜子之外。',
    title2: '颜色与情感',
    content2: '一个没有颜色的世界是一个不存在的世界。将由您来给这一层的各个隐蔽角落填充颜色，复原结构和重建环境。',
    title3: '光线与实体',
    content3: '光线可以成为空间中实体存在的记号。使用您的化身光痕来生成通道，以通向之前无法到达的区域。光线会产生阴影，但同时道路也会变得真实。',
    title4: '光线与沉浸',
    content4: '光线可与空间相融合。寻找您的光痕和影子之间的平衡。您在空间中的移动会产生意想不到的形态，直到您发现这阴影最终会成为您的创作作品。',
    title5: ' 颜色与修行',
    content5: '您在这个抽象形态的彩色空间中散步，在这里每一个区域都要通过被分配的物体和颜色来激活。尝试将它们形状象征和色彩代码配对。',
    title6: '颜色与契约',
    content6: '在一个无人化大都市背景下，城市居民就是一种资源，他们可以发现某些通道，而城市变成了一个大型操控机制。',
    title7: '颜色和作用',
    content7: '在一件作品中，颜色可以起到独特的作用，有其特定的所指。在这一层里，每一种颜色都有明确的功能。由您来为没有颜色的内容填入相应的颜色。'
  },
  prod: {
    text1: '在教育和青年部的支持下制作',
    text2: '由蓬皮杜艺术中心，社会游戏和光明会开发的游戏，配乐由Ircam Amplify专门编写',
    link: '链接到新闻稿'
  },
  available: {
    date: '现在有空'
  },
  download: {
    exe: '下载可执行文件'
  }
}

export default messages
